export default "__VITE_ASSET__79fff04d__"